module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gRqPW"))).then(() => parcelRequire('iDabs'));